/**
 * Authentication slice for the application store.
 * Handles user authentication state and actions.
 */

import type { User } from '../types';
import type { StateCreator } from 'zustand';

/**
 * Authentication state and actions.
 */
export interface AuthSlice {
  // State
  user: User | null;
  isAuthenticated: boolean;
  authToken: string | null;

  // Actions
  setAuth: (user: User | null, token: string | null) => void;
  setAuthenticated: (authenticated: boolean) => void;
  clearAuth: () => void;
}

/**
 * Creates the authentication slice.
 */
export const createAuthSlice: StateCreator<AuthSlice, [], [], AuthSlice> = set => ({
  // Initial state
  user: null,
  isAuthenticated: false,
  authToken: null,

  // Actions
  setAuth: (user, token) =>
    set({
      user,
      authToken: token,
      isAuthenticated: !!token,
    }),

  setAuthenticated: authenticated =>
    set({
      isAuthenticated: authenticated,
      ...(authenticated ? {} : { user: null, authToken: null }),
    }),

  clearAuth: () =>
    set({
      user: null,
      authToken: null,
      isAuthenticated: false,
    }),
});
